import React from 'react';
import { ArrowRight, BarChart3, Target, Zap, Database } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { StatBlock } from '../components/ui/StatBlock';
import { ClientTicker } from '../components/ui/ClientTicker';
import { Input } from '../components/ui/Input';
export function Home() {
  return <div className="w-full" data-id="element-831" data-mp="1ziqqpcashcgg">
      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[85vh] flex items-center justify-center pt-20 py-10 md:py-16 overflow-hidden" data-id="element-832" data-mp="1zkabng7e4bok">
        {/* Cinematic background gradient/glow */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.05)_0%,rgba(0,0,0,1)_70%)]" data-id="element-833" data-mp="29i7zi2lc86gn" />

        <div className="relative z-10 max-w-5xl mx-auto px-4 text-center flex flex-col items-center mt-12 md:mt-16" data-id="element-834" data-mp="3kvk4igsu2v4e">
          <span className="text-engage-yellow font-bold tracking-[0.1em] text-[9px] xs:text-[10px] sm:text-xs md:text-base mb-4 uppercase animate-fade-in-up whitespace-nowrap" data-id="element-835" data-mp="3ow419j9hvwq0">
            Content Creation | Paid Advertising | Funnels
          </span>
          <h1 className="md:text-7xl lg:text-8xl font-black text-engage-white mb-5 tracking-tight text-balance text-[35px]" data-id="element-836" data-mp="2vvltoav6nw2b">
            Where Creativity Meets{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-engage-white to-engage-gray4" data-id="element-837" data-mp="2mw8lrmmpjfjp">
              Performance
            </span>
          </h1>
          <p className="text-lg md:text-xl text-engage-gray4 max-w-2xl mb-7 text-balance" data-id="element-838" data-mp="2d6ozs83p75km">
            We build growth engines that move people, drive action, and generate
            real revenue for ambitious brands.
          </p>
          <Button to="/contact" variant="primary" className="text-lg px-8 py-4" data-id="element-839" data-mp="23alzz8wbjj0u">
            Book a Call With Us
          </Button>
        </div>
      </section>

      {/* Client Logos Carousel Section */}
      <section className="py-12 bg-engage-gray1 relative overflow-hidden" data-id="element-840" data-mp="1u8uuo55oxe7i">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(252,198,13,0.03)_0%,transparent_60%)] pointer-events-none" data-id="element-841" data-mp="1kjnwp8n4mdz3" />
        <div className="relative z-10 max-w-7xl mx-auto px-4" data-id="element-842" data-mp="1ok7w6iv69toe">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-843" data-mp="1anumhvwvqwkh">
            {/* Chip/Tag Label - centered on mobile, left on desktop */}
            <span className="border-2 border-engage-yellow text-engage-white text-xs font-semibold uppercase tracking-wide px-4 py-2 rounded-full whitespace-nowrap shrink-0" data-id="element-844" data-mp="23bgq3463y17c">
              Trusted by Leading Brands
            </span>
            {/* Carousel taking remaining space */}
            <div className="w-full md:flex-1 relative overflow-hidden" data-id="element-845" data-mp="1tjkohj4tbsyd">
              <div className="flex" data-id="element-846" data-mp="1yinmijmdkywu">
                {[0, 1].map(setIndex => <div key={setIndex} className="flex shrink-0 items-center gap-8 md:gap-16 pr-8 md:pr-16 animate-logo-scroll" data-id="element-847" data-mp="2m9axjdrl84nm">
                    <img src="https://cdn.magicpatterns.com/uploads/6kgibo1RnRcCbDvKVJS3Lu/Logo-The-Christmas-Palace.png" alt="The Christmas Palace" className="h-20 w-auto object-contain shrink-0" data-id="element-848" data-mp="fksgo5u101md" />
                    <img src="https://cdn.magicpatterns.com/uploads/9m9ezirWgVJHARCigZFgh9/Z-Roofing.png" alt="Z Roofing" className="h-20 w-auto object-contain shrink-0" data-id="element-849" data-mp="kcaewm4nzo3n" />
                    <img src="https://cdn.magicpatterns.com/uploads/wJhjYS3o8Eu6CBJ2vRY5Wa/Logo-Level-Up-Insurance.png" alt="Level Up Insurance" className="h-20 w-auto object-contain shrink-0" data-id="element-850" data-mp="3nvluydap7ne6" />
                    <img src="https://cdn.magicpatterns.com/uploads/gFP8PtEhJGxGGu1ofodZsj/Logo-Xclusive-Agent-Leads.png" alt="Xclusive Agent Leads" className="h-20 w-auto object-contain shrink-0" data-id="element-851" data-mp="1h0ykuk33vkwp" />
                    <img src="https://cdn.magicpatterns.com/uploads/mhHKTX4VkSDNuJTWP1gncJ/Logo-Casa-Wagyu.png" alt="Casa Wagyu" className="h-20 w-auto object-contain shrink-0" data-id="element-852" data-mp="2cdret0yr0in5" />
                    <img src="https://cdn.magicpatterns.com/uploads/m3d8to4jrYnQ7wdpBu4LqM/Logo-Omnicredit.png" alt="Omnicredit" className="h-20 w-auto object-contain shrink-0" data-id="element-853" data-mp="2qdakzo801jwt" />
                    <img src="https://cdn.magicpatterns.com/uploads/ePG9ymzHfpNVHNd8RfG8sQ/Logo-Winners-Mindset.png" alt="Winners Mindset" className="h-20 w-auto object-contain shrink-0" data-id="element-854" data-mp="304wpz2tqumr4" />
                    <img src="https://cdn.magicpatterns.com/uploads/2ScwJcYowcVKwXTHwUS5pZ/Logo-Watch-Me-Grow-Learning-Center.png" alt="Watch Me Grow Learning Center" className="h-20 w-auto object-contain shrink-0" data-id="element-855" data-mp="3e2v0fx4y1z1c" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Ticker */}
      <ClientTicker data-id="element-856" data-mp="1m3h4wf9h4gcf" />

      {/* Intro Section */}
      <section className="py-24 md:py-32 bg-engage-black" data-id="element-857" data-mp="1m260qec496ks">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-858" data-mp="1h3mcu8dypkps">
          <h2 className="text-3xl md:text-[56px] font-bold text-engage-white mb-4 tracking-tight" data-id="element-859" data-mp="1h68n4fs8mebp">
            We don't just market your brand.
          </h2>
          <h2 className="text-5xl md:text-7xl font-black text-engage-yellow mb-8 tracking-tight" data-id="element-860" data-mp="17d9wyth3efpz">
            We Engage it.
          </h2>
          <p className="text-xl md:text-2xl text-engage-gray4 mb-12 leading-relaxed text-balance" data-id="element-861" data-mp="24va0mhfxgfnu">
            From content to ads to conversion systems, we build growth engines
            that move people, drive action, and generate real revenue.
          </p>
          <Button to="/case-studies" variant="secondary" data-id="element-862" data-mp="26a1jwew47l7">
            See Our Results
          </Button>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 bg-engage-gray1 border-y border-engage-gray2 relative overflow-hidden" data-id="element-863" data-mp="3pjcc5cpwt0xo">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(252,198,13,0.03)_0%,transparent_70%)]" data-id="element-864" data-mp="3am3fq4lr16z3" />
        <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-865" data-mp="3fjbq3j0no6ps">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-866" data-mp="31n8aauqj40wu">
            Our Results, Your Growth
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-867" data-mp="36n4646p2om1b">
            <StatBlock number="$80M+" label="Annual Client Revenue" data-id="element-868" data-mp="zv3cx3q9gbeq" />
            <StatBlock number="$1.3M+" label="Ad Spend Per Year" data-id="element-869" data-mp="14twqsx9gm4ff" />
            <StatBlock number="16" label="Engage Marketers" data-id="element-870" data-mp="1exl8q95vdbps" />
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-24 md:py-32 bg-engage-black" data-id="element-871" data-mp="19za207avfhbs">
        <div className="max-w-7xl mx-auto px-4" data-id="element-872" data-mp="1npvkhuwexp95">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-16 gap-6 text-center md:text-left" data-id="element-873" data-mp="1nqovj82en0x3">
            <div data-id="element-874" data-mp="1ix2gj98rqky4">
              <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-875" data-mp="1xo2yc4venr6x">
                The Engage Machine
              </h2>
              <p className="text-engage-gray4 text-lg max-w-xl mx-auto md:mx-0" data-id="element-876" data-mp="1spi0ud7jflm6">
                A unified engine combining media buying, creative production,
                and funnel strategy.
              </p>
            </div>
            <Button to="/services" variant="secondary" className="shrink-0" data-id="element-877" data-mp="22nnygimba5l8">
              Let's Scale
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-878" data-mp="894vyg1rs237">
            <Card accent className="group cursor-pointer" data-id="element-879" data-mp="8apu0fnam35t">
              <Target className="w-12 h-12 text-engage-yellow mb-6" data-id="element-880" data-mp="wuv0221yulx3" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-881" data-mp="11t69ibocmues">Conversion</h3>
              <p className="text-engage-gray4" data-id="element-882" data-mp="11rbnsv596y9n">
                Turn your website into a system that converts attention into
                customers.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-883" data-mp="1akyg2ba95je3">
              <Zap className="w-12 h-12 text-engage-yellow mb-6" data-id="element-884" data-mp="dvqtczxwd48l" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-885" data-mp="dxa7ajw2z377">Content</h3>
              <p className="text-engage-gray4" data-id="element-886" data-mp="iv3ffigy27a4">
                Create content that captures attention and drives action.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-887" data-mp="ruqjkc125r6v">
              <ArrowRight className="w-12 h-12 text-engage-yellow mb-6" data-id="element-888" data-mp="rw9zg1isy084" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-889" data-mp="1ya9894dje5gm">Traffic</h3>
              <p className="text-engage-gray4" data-id="element-890" data-mp="239voznskq3u6">
                Bring the right people into your business, consistently.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-891" data-mp="2ddamdrmpjw68">
              <Database className="w-12 h-12 text-engage-yellow mb-6" data-id="element-892" data-mp="28epnpwn3tkjw" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-893" data-mp="23o0wmifc6pla">Data</h3>
              <p className="text-engage-gray4" data-id="element-894" data-mp="23mg38w4rdcp0">
                Use performance data to make smarter decisions and scale faster.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Case Studies Preview */}
      <section className="py-24 md:py-32 bg-engage-gray1" data-id="element-895" data-mp="1porj5qiim9l0">
        <div className="max-w-7xl mx-auto px-4" data-id="element-896" data-mp="1pqkp13lb0pry">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-16 gap-6 text-center md:text-left" data-id="element-897" data-mp="1komydoakqsoz">
            <h2 className="text-4xl md:text-5xl font-bold" data-id="element-898" data-mp="1gpe5smr9t0v0">Case Studies</h2>
            <Button to="/case-studies" variant="secondary" className="shrink-0" data-id="element-899" data-mp="3f2eff8v8geug">
              Explore All Case Studies
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-900" data-mp="col7kjq29bgc">
            <Card accent className="flex flex-col h-full group" data-id="element-901" data-mp="cn0fr1v4s6m6">
              <div className="flex-grow" data-id="element-902" data-mp="8nrj9p8phumx">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-903" data-mp="8p2nfq62d4ek">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-904" data-mp="mlpw2q7dpj0b">
                    Lead Gen
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-905" data-mp="3q2pvl2n7slcg">
                    Paid Social
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-906" data-mp="3o6iradw1e83">
                    Financial Services
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-907" data-mp="37bfc36jtjaul">
                  Omnicredit
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-908" data-mp="1hvcnri8o426r">
                  From Zero to $40K/Month in Just 4 Months
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-909" data-mp="18vg640kp43l7">
                  How we built a complete acquisition system from scratch for an
                  early-stage financial brand—going from zero infrastructure to
                  $40K/month in just four months.
                </p>
              </div>
              <Link to="/case-studies/omnicredit" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-910" data-mp="25lywlbqhxqht">
                <span data-id="element-911" data-mp="1wixr9d9gg3f7">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-912" data-mp="g6sfdph6gm09" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-913" data-mp="l76o79qlrzzc">
              <div className="flex-grow" data-id="element-914" data-mp="2mv1536hykbu8">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-915" data-mp="2mtzrovdgzd9c">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-916" data-mp="2hvevr8593fqp">
                    E-Commerce Growth
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-917" data-mp="292bk95e61cyp">
                    Multi-Channel Scaling
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-918" data-mp="1z3vpmsfxjlkg">
                  The Christmas Palace
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-919" data-mp="1q5k24zad13w8">
                  Turning Content into Holiday Demand at Scale
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-920" data-mp="3ki9z5pw0yt7u">
                  How we built a content-first growth engine that generated 8M+
                  views in 90 days, turning social content into real-world
                  holiday demand and foot traffic.
                </p>
              </div>
              <Link to="/case-studies/christmas-palace" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-921" data-mp="1g1mx72o45awy">
                <span data-id="element-922" data-mp="ne981qqnpjne">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-923" data-mp="sc0xme3twtof" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-924" data-mp="wep5aigt3ujt">
              <div className="flex-grow" data-id="element-925" data-mp="11cgxzep9zkp2">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-926" data-mp="27rrollaaiy7o">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-927" data-mp="27r84pz12xzr0">
                    Scaling
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-928" data-mp="2bagqpi4iecwv">
                    Paid Search
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-929" data-mp="2kboolz345bqf">
                  Levelup Insurance
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-930" data-mp="2u7hxn8hmin3g">
                  Scaling High-Quality Leads Nationwide
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-931" data-mp="33yurg5mzfnc4">
                  How we built a bilingual lead acquisition system that scaled
                  from $3K to $70K/month in ad spend—while improving lead
                  quality and expanding nationwide.
                </p>
              </div>
              <Link to="/case-studies/levelup-insurance" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-932" data-mp="380pqf3hfxomq">
                <span data-id="element-933" data-mp="dca94bh3qhe">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-934" data-mp="3iltc9hrc3jhv" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-935" data-mp="3moq29tj7ehvu">
              <div className="flex-grow" data-id="element-936" data-mp="38uglkth9uzdf">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-937" data-mp="38tf86icsa0sj">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-938" data-mp="3dmqiwukpv1pq">
                    Local Service
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-939" data-mp="33wx9o081qyon">
                    Brand Authority
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-940" data-mp="2uxjwoxkprrz6">
                  Z Roofing and Waterproofing
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-941" data-mp="vnqsutvezj7s">
                  Building a Trusted Local Brand
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-942" data-mp="mon8lmkigxrp">
                  How we transformed a local roofing company's digital presence
                  into a trust-building asset—aligning their online image with
                  the quality of their work.
                </p>
              </div>
              <Link to="/case-studies/z-roofing" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-943" data-mp="1acdgrjz3xjam">
                <span data-id="element-944" data-mp="3v1kp87jfpaho">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-945" data-mp="3q4b2iznfjcxj" />
              </Link>
            </Card>
          </div>
        </div>
      </section>

      {/* Careers Section */}
      <section className="py-32 bg-engage-black relative overflow-hidden" data-id="element-946" data-mp="2ameke554bwkd">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(252,198,13,0.08)_0%,transparent_60%)]" data-id="element-947" data-mp="2emye0yqhgi1r" />
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-948" data-mp="2jeq4l99n2nrw">
          <span className="text-engage-yellow font-bold tracking-[0.2em] text-sm uppercase mb-6 block" data-id="element-949" data-mp="2odszw1zthfmo">
            Join Our Team
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-balance" data-id="element-950" data-mp="2te7c7w8gbbqi">
            Build the Future of Performance Marketing
          </h2>
          <p className="text-engage-gray4 text-lg md:text-xl mb-10 max-w-2xl mx-auto text-balance" data-id="element-951" data-mp="32bre97e51c26">
            We're always looking for ambitious, analytical, creative minds ready
            to scale brands globally.
          </p>
          <Button to="/careers" variant="primary" className="text-lg px-8 py-4" data-id="element-952" data-mp="17z1j6mc19wt7">
            Explore Open Positions
          </Button>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-24 bg-engage-gray1" data-id="element-953" data-mp="k36a6taxmy4m">
        <div className="max-w-2xl mx-auto px-4" data-id="element-954" data-mp="xvco08qm4t0w">
          <Card className="bg-engage-black border border-engage-gray2 text-center" data-id="element-955" data-mp="xu1k88x63l9s">
            <div className="mb-8" data-id="element-956" data-mp="ttrij8gerh0q">
              <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-957" data-mp="tvluhx9pbyso">
                Stay Ahead of the Curve
              </h3>
              <p className="text-engage-gray4 text-lg" data-id="element-958" data-mp="153ooohlfjbk">
                Get weekly insights on performance marketing, creative strategy,
                and scaling brands delivered to your inbox.
              </p>
            </div>
            <form className="flex flex-col sm:flex-row gap-4" onSubmit={e => e.preventDefault()} data-id="element-959" data-mp="a4gyxjdjkbxc">
              <Input label="" placeholder="Enter your email" type="email" className="flex-grow !space-y-0" required data-id="element-960" data-mp="1lkfi4g2foeca" />
              <Button type="submit" variant="primary" className="whitespace-nowrap px-8" data-id="element-961" data-mp="1y2rn735156wn">
                Subscribe
              </Button>
            </form>
          </Card>
        </div>
      </section>
    </div>;
}